'use client';

import { ComponentProps } from 'react';

import { useIdleRefresh } from './shared-survey-idle-refresh.hooks';
import { ProjectResponseModeProvider } from './shared-survey-project-response-mode-provider';

type Props = ComponentProps<typeof ProjectResponseModeProvider>;

export function ProjectResponseWithIdleRefreshProvider({
  children,
  ...rest
}: Props) {
  useIdleRefresh();
  return (
    <ProjectResponseModeProvider {...rest}>
      {children}
    </ProjectResponseModeProvider>
  );
}
